// extracted by mini-css-extract-plugin
module.exports = {"modal":"DevicesPopup_modal__2Npz7"};